export const HopperCancellationPolicies = [
  {
    value: 'flexible',
    label: 'Flexible',
    tootip: $localize`Full refund 1 day prior to arrival`,
  },
  {
    value: 'moderate',
    label: 'Moderate',
    tootip: $localize`Full refund 5 days prior to arrival`,
  },
  {
    value: 'strict',
    label: 'Strict',
    tootip: $localize`Full refund for cancellations made within 48 hours of booking, if the check-in date is at least 14 days away. 50% refund for cancellations made at least 7 days before check-in. No refunds for cancellations made within 7 days of check-in`,
  },
  {
    value: 'non-refundable',
    label: 'Non-refundable',
    tootip: $localize`No refund on cancellations at any time`,
  },
]
